"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 35: J.Y. Company ASIC (with 8 KiB WRAM)
 * ------------------------------------------------------------------ *
 * Mapper 35 is identical to mapper 90 (J.Y. Company ASIC) except that
 * it explicitly specifies 8 KiB of WRAM. In the presence of a valid
 * NES 2.0 header, mapper 35 is an exact duplicate of mapper 90.
 *
 * We simply reuse the J.Y. Company implementation from jycompany.js.
 * ------------------------------------------------------------------ */

function register(Mappers) {
  // Require the J.Y. Company module and register it as mapper 35.
  var jycompany = require("./jycompany");
  // The jycompany module registers mapper 90. We need to copy its
  // constructor to mapper 35.
  jycompany.register(Mappers);
  Mappers[35] = Mappers[90];
}

module.exports = { register: register };
